

<!--start footer-->

<footer class="pt-5">
    <div class="container pt-5">
        <div class="row">
            <div class="col-lg-3 col-md-6 mb-3">
                <div class="footer-head">
                    <img src="assets/images/logo-light.png" class="img-fluid" alt="logo">
                    <p class="pt-3">Lorem ipsum dlor amet, consetetur sadipscing esed dia nonumy eirmod tempor invidunt.</p>
                    <div class="text-white">
                        <i class="fab fa-facebook-f pr-4"></i>
                        <i class="fab fa-twitter pr-4"></i>
                        <i class="fab fa-google pr-4"></i>
                        <i class="fab fa-linkedin-in pr-4"></i>
                        <i class="fab fa-youtube pr-4"></i>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 mb-3">
                <div class="card-footers pt-2">
                    <h2 class=" text-white">Contact Us</h2>
                    <div class=" pt-3 card-footers">
                        <p>
                          <i class="fas fa-map-marker-alt pr-3"></i>
                          3699 Wescam Court, Quincy
                        </p>
                        <p>
                          <i class="fas fa-phone-alt pr-3"></i>
                          0 (800) 123 4561
                        </p>
                        <p class="second">
                          <i class="fas fa-envelope pr-3"></i>
                          pharmacom@example.com
                        </p>
                    </div>
                    
                </div>
            </div>
            <div class="col-lg-3 col-md-6 mb-3">
                <div class="card-footers pt-2">
                    <h2 class="text-white">Twitter Widget</h2>
                    <p class="pl-1">
                        loading twitter feed...
                    </p> 
                </div>
            </div>
            <div class="col-lg-3 col-md-6 mb-3">
                <div class="card-footers pt-2">
                    <h2 class="text-white">Instagram</h2> 
                </div>
            </div>








        </div>
    </div>

    
        <div class="footer-cover pt-3 pb-2 mt-5 text-center">
            <p>©2020. All Rights Reserved. Designed with by Taha</p>
        </div>

</footer>

<!--end footer-->